import React from 'react'
import { StyleSheet, View, Text } from 'react-native'
import {
    Spinner,
    HStack,
    Heading,
    Center,
    NativeBaseProvider,
} from "native-base"
import theme from '../../constants/theme'

export default function Loading(props) {
    return (
        <NativeBaseProvider theme={theme}>
            <Center flex={1}>
                <HStack space={2} >
                    <Spinner  color={theme.colors.primary[100]}/>
                </HStack>
            </Center>
        </NativeBaseProvider>
    )
}
